export default __webpack_public_path__ + "static/media/Peach waves2.25ac154b.jpg";